import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingPersonUpsert, ITrainingPerson, IGetPutRequest } from '../../interfaces'

const getUpdateTrainingPersonMutationRequest: IGetPutRequest = params => {

  return {
    method: 'put',
    url: `${config.baseUrl}/People/`,
  }
}

const useUpdateTrainingPersonMutation: IUseUpdateMutation<ITrainingPerson, ITrainingPersonUpsert> = (params, options = {}) => {
  const request = useMemo(() => getUpdateTrainingPersonMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingPersonUpsert, ITrainingPerson> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.id, data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPerson, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateTrainingPersonMutation
